/**
 * Created by Mark on 24/11/2016.
 */

import BaseStore from './base-store.js';
import Constants from '../constants/scores.js';

const dataKeys = [{key:'reading' , fill:'#fd470a'} , {key:'listening' , fill:'#ff8417'} , {key:'writing' , fill:'#fa74b7'} , {key:'speaking' , fill:'#1b9ff6'}];


class ScoresStore extends BaseStore {

    constructor() {
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.accountLevel = [];
        this.classLevel= [];
    }


    _processAverages(data){

        const colors = {'reading':'#fd470a' , 'listening':'#ff8417' , writing:'#fa74b7' , speaking:'#1b9ff6' }

        var response = [];
        for(var key in data){
            if(!data.hasOwnProperty(key)) continue;
            var entry =  data[key];
            response.push({name:entry.type , score:Number(entry.score) , fill:colors[entry.type]})
        }

        return response;
    }

    _registerToActions(action) {


        switch(action.actionType)
        {
            case Constants.UPDATE_AVERAGE_ACCOUNT_LEVEL:
                this.accountLevel = this._processAverages(action.response);
                this.emitChange();
                break;
            case Constants.UPDATE_TOTAL_CLASS_LEVEL:
                this.classLevel = this._processAverages(action.response);
                console.log(this.classLevel)
                this.emitChange();
                break;
            case Constants.UPDATE_TOTAL_STUDENT_LEVEL:
                this.studentLevel = this._processAverages(action.response);
                this.emitChange();
                break;
            case Constants.UPDATE_CLASS_SCORES:
                this.scores = action.response;
                this.emit("SCORE_UPDATE");
                break;
        }
    }

    getAccountAverage(){
        return this.accountLevel;
    }

}

export default new ScoresStore();


// WEBPACK FOOTER //
// ./src/store/scores-store.js